export default "__VITE_ASSET__CTO_y$gX__"